module.exports = __webpack_public_path__ + "img/icon-baccarat-21.2cdb1afc.png";